global.AUTH_CODE = null;
global.MAIL = null;
global.LOGGED = null;
global.FETCHURL = null;

global.COMESFROM = "Currencies";

export default global;
